/* eslint-disable eqeqeq */
import { useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "./assets/css/App.scss";
import { APP_PREFIX_PATH } from "./config/AppConfig";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Profile from "./pages/Profile";
import Header from "./components/Header";
import Authentication from "./pages/auth/authentication";
import ManageContent from "./pages/ManageContent";
import Register from "./pages/Register.js";

// PrivateRoute for protected pages
const PrivateRoute = ({ children }) => {
  const token = sessionStorage.getItem("token");
  return token ? children : <Home />; // redirect to Home if no token
};

function App() {
  const location = useLocation();
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);

  // Hide Header if Login or Registration page
  const hideHeaderPages = [
    `/${APP_PREFIX_PATH}/login`,
    `/${APP_PREFIX_PATH}/register`,
  ];
  const showHeader = !hideHeaderPages.includes(location.pathname);

  return (
    <>
      <Authentication />
      {showHeader && <Header toggleSidebar={toggleSidebar} />}
      <div className="main" style={{ marginTop: showHeader ? 110 : 0 }}>
        <div
          className={
            isSidebarVisible ? "main-content" : "main-content w-100 ms-0"
          }
        >
          <div className="content">
            <Routes>
              <Route path={`${APP_PREFIX_PATH}/`} element={<Home />} />
              <Route path={`${APP_PREFIX_PATH}/login`} element={<Login />} />
              <Route path={`${APP_PREFIX_PATH}/register`} element={<Register />} /> 
              {/* Replace with Register component if you have */}
              <Route
                path={`${APP_PREFIX_PATH}/profile`}
                element={
                  <PrivateRoute>
                    <Profile />
                  </PrivateRoute>
                }
              />
            </Routes>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
